<script>
import { BBreadcrumb } from "bootstrap-vue";

export default {
  extends: BBreadcrumb
};
</script>